import { useQuery } from '@tanstack/react-query';
import type { Mentionable } from '../../lib/comment-types';
import type { AuthorsSource } from './authors';

/** Names of these authors on the board, one request per set of ids, cached a minute; null while loading. */
export function useAuthorNames(source: AuthorsSource, ids: string[]): ReadonlyMap<string, Mentionable> | null {
  const others = ids.filter((id) => id !== source.me);
  const query = useQuery({
    queryKey: ['authors', source.boardId, ...others],
    queryFn: () => source.resolve(others),
    enabled: others.length > 0,
    staleTime: 60_000,
  });
  if (!others.length) return new Map();
  return query.data ? new Map(query.data.map((m) => [m.userId, m])) : query.isError ? new Map() : null;
}
